import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';

import { Icon } from 'components/Icon';
import { InputAutoCompleteOptions } from './components/InputAutoCompleteOptions.jsx';

const InputAutoComplete = ({ icon, size, onChange, list, selected, placeholder, className, height }) => {
  const wrapperRef = useRef(null);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    function handleClickOutside(event) {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setOpen(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [wrapperRef]);

  const handleSelect = (item) => {
    onChange(item);
  };
  const style = {};
  if (size) {
    style.width = size;
  }
  if (height) {
    style.height = height;
  }

  return (
    <div className={`input-autocomplete-with-icon ${className}`} ref={wrapperRef}>
      <div className={`selector icon-selector ${open ? 'is-open' : ''}`} style={style}>
        <InputAutoCompleteOptions
          selected={selected || {}}
          open={open}
          setOpen={setOpen}
          placeholder={placeholder}
          options={list}
          onClick={handleSelect}
          className={className}
        />

        <div className="icon-position">
          <Icon name={icon} />
        </div>
      </div>
    </div>
  );
};

InputAutoComplete.propTypes = {
  icon: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  selected: PropTypes.shape({
    text: PropTypes.string,
    value: PropTypes.any,
    returning: PropTypes.any,
  }),
  size: PropTypes.string,
  height: PropTypes.string,
  placeholder: PropTypes.string,
  list: PropTypes.array,
};

InputAutoComplete.defaultProps = {
  icon: 'search',
  selected: null,
  placeholder: 'Search...',
  size: '150px',
  height: 'auto',
  style: [],
};

export { InputAutoComplete };
